<template>
  <div v-if="!isLoading && !error" :style="getCssVaraibles" class="all-prices-component container">
    <div class="header">
      <span class="horizontal-line"></span>
      <prismic-rich-text v-if="title" class="bolder" :field="title"> </prismic-rich-text>
      <span class="horizontal-line"></span>
    </div>
    <ul
      v-if="firstColumnSpecs && secondaColumnSpecs"
      class="specs-list list-group list-group-flush"
    >
      <li class="list-group-item">
        <SpecList :specs="firstColumnSpecs" />
      </li>
      <li class="list-group-item">
        <SpecList :specs="secondaColumnSpecs" />
      </li>
      <li class="line-vertical"></li>
    </ul>

    <Button
      class="m-auto"
      :with-gradient="true"
      gradient="linear-gradient(180deg, var(--quinary-color) 0, var(--senary-color) 100%);"
      @click="
        $scrollTo(buttonLink, 500, {
          offset: -50
        })
      "
    >
      {{ buttonText }}
    </Button>
  </div>
</template>

<script>
import Button from 'UI/Button';
import SpecList from '@/components/Prismic/Landings/Slices/AllPrices/SpecList.vue';
export default {
  components: { Button, SpecList },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      title: null,
      specs: [],
      buttonText: null,
      buttonLink: null,
      isLoading: true,
      error: false
    };
  },
  computed: {
    getCssVaraibles() {
      const {
        primary_color: primaryColor,
        secondary_color: secondaryColor,
        terciary_color: terciaryColor,
        quaternary_color: quaternaryColor,
        quinary_color: quinaryColor,
        senary_color: senaryColor
      } = this.slice.primary;

      return `
            --primary-color: ${primaryColor};
            --secondary-color: ${secondaryColor};
            --terciary-color: ${terciaryColor};
            --quaternary-color: ${quaternaryColor};
            --quinary-color: ${quinaryColor};
            --senary-color: ${senaryColor};
        `;
    },
    firstColumnSpecs() {
      return this.specs.slice(0, Math.ceil(this.specs.length / 2));
    },
    secondaColumnSpecs() {
      return this.specs.slice(Math.ceil(this.specs.length / 2));
    }
  },
  created() {
    try {
      const { items, primary } = this.slice;

      this.title = primary.title1;
      this.buttonText = primary.button_text;
      this.buttonLink = primary.button_anchor_id_target;

      this.specs = items.map((item) => {
        const { spec_title: title, sub_specs: subSpecsStr, tooltip_text: tooltipText } = item;
        const subSpecs = this.getSubSpecs(subSpecsStr);
        return { title, subSpecs, tooltipText };
      });
      this.isLoading = false;
    } catch (error) {
      console.error(error);
      this.error = true;
    }
  },
  methods: {
    getSubSpecs(specsStr) {
      return specsStr.split(',').map((spec) => spec.trim());
    }
  }
};
</script>
<style lang="scss" scoped>
.all-prices-component {
  display: grid;
  gap: 2em;
  background-color: var(--secondary-color);
  color: var(--primary-color);
  border: 1px solid var(--quaternary-color);
  border-radius: 46px;
  padding: 2em;
  @include min-md {
    padding: 2em 4em;
  }
  p {
    margin: 0;
  }
  .bolder {
    font-weight: 600;
  }
  .list-group-item {
    background-color: inherit;
    border: inherit;
    padding: 0;
  }

  .header {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 1em;
    .horizontal-line {
      width: 100%;
      height: 1px;
      background-color: var(--primary-color);
      opacity: 0.3;
    }
  }
  .specs-list {
    display: grid;
    grid-template-columns: 1fr;

    gap: 4em;
    @include min-md {
      grid-template-columns: 1fr auto 1fr;
    }

    .line-vertical {
      grid-area: 1/2 / 2 / 3;
      background: var(--primary-color);
      opacity: 0.3;
      width: 1px;
      list-style: none;
      display: none;
      @include min-md {
        display: block;
      }
    }
  }
}
</style>
